<template>
  <div class="flex flex-wrap outline-text-sm" style="font-size: 1.2rem">
    <div v-for="option in filterOptions" :key="option" class="select-none">
      <div class="mr-6 items-center text-2xl" :class="{'font-bold': isSelected(option), 'text-dark': isSelected(option), 'cursor-pointer': isNotSelected(option), 'hover:text-warning': isNotSelected(option)}" @click="handleClick(option)">
        {{option}}
        <feather-icon v-if="icon(option)" :icon="icon(option)" svgClasses="h-4 w-4" />
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'

export default {
  components: {
  },
  props: ['value', 'filterOptions', 'getInspiredIcon'],
  data () {
    return {
      localValue: null,
    }
  },
  // mounted () {
  //   this.localValue = this.value
  // },
  methods: {
    icon (option) {
      if (_.includes(option, 'get inspired')) {
        return this.getInspiredIcon || 'UsersIcon'
      }
    },
    isSelected (option) {
      return _.includes(this.localValue, option)
    },
    isNotSelected (option) {
      return !this.isSelected(option)
    },
    handleClick (option) {
      this.localValue = [option]
      // if (this.isSelected(option)) {
      //   this.localValue = _.difference(this.localValue, [option])
      // } else {
      //   this.localValue = _.concat(this.localValue, [option])
      // }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (value) {
        this.localValue = value
      }
    },
    localValue: {
      immediate: false,
      handler (localValue) {
        this.$emit('input', localValue)
      }
    }
  },
}
</script>
